import Layout from "@/components/Layout";
import { CONTACT, LOGO_URL } from "@/lib/constants";
import { Phone, Mail, MapPin } from "lucide-react";

export default function ContactPage() {
  return (
    <Layout>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-[#1D4ED8]">Contact us</div>
          <h1 className="font-heading font-black text-4xl sm:text-5xl mt-2 text-slate-900">Let's talk.</h1>
          <p className="mt-4 text-slate-600 max-w-md">
            Got a job? A question? Need a custom quote? Reach out — we answer fast.
          </p>
          <div className="mt-8 space-y-4">
            <a href={`tel:${CONTACT.phone}`} className="flex items-center gap-3 group" data-testid="contact-phone">
              <div className="h-11 w-11 rounded-md bg-[#E32636] text-white flex items-center justify-center"><Phone className="h-5 w-5" /></div>
              <div>
                <div className="text-xs uppercase font-bold tracking-wider text-slate-500">Phone</div>
                <div className="font-bold text-slate-900 group-hover:text-[#E32636]">{CONTACT.phone}</div>
              </div>
            </a>
            <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 group" data-testid="contact-email">
              <div className="h-11 w-11 rounded-md bg-[#1D4ED8] text-white flex items-center justify-center"><Mail className="h-5 w-5" /></div>
              <div>
                <div className="text-xs uppercase font-bold tracking-wider text-slate-500">Email</div>
                <div className="font-bold text-slate-900 group-hover:text-[#1D4ED8]">{CONTACT.email}</div>
              </div>
            </a>
            <div className="flex items-center gap-3">
              <div className="h-11 w-11 rounded-md bg-slate-900 text-white flex items-center justify-center"><MapPin className="h-5 w-5" /></div>
              <div>
                <div className="text-xs uppercase font-bold tracking-wider text-slate-500">Office</div>
                <div className="font-bold text-slate-900">{CONTACT.address}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="relative aspect-[4/3] rounded-md overflow-hidden border border-slate-200 bg-gradient-to-br from-red-50 via-white to-blue-50 flex items-center justify-center p-10">
          <img src={LOGO_URL} alt="Cleavie's Enterprise" className="max-h-full max-w-full object-contain" />
        </div>
      </section>
    </Layout>
  );
}
